import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Clients from "../components/Clients";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="relative overflow-x-hidden">
            <Navbar />
            <Hero />
            <About />
            <Services />
            <Clients />
            <Testimonials />
            <Contact />
            <Footer />
        </main>
    );
}
